module["exports"] = ["ukr.net", "ex.ua", "e-mail.ua", "i.ua", "meta.ua", "yandex.ua", "gmail.com"];